import { relativeDay } from '../../core/format/dates'
import { fromCents } from '../../core/format/currency'
import type { FulfilmentStatus, InboxOrder, PaymentStatus } from '../../core/types/adminRequests'

/** Het betaalde bedrag, zoals de server het rekende. Niet opnieuw rekenen met de huidige prijzen. */
export const inboxOrderTotal = (o: InboxOrder) => fromCents(o.totalCents)

/** Alleen betaalde bestellingen gaan de doos in. */
export const isPaid = (o: InboxOrder) => o.payment.status === 'betaald'
export const isToPack = (o: InboxOrder) => o.status === 'nieuw' && isPaid(o)

export const paymentLabel: Record<PaymentStatus, string> = {
  open: 'Wacht op betaling',
  betaald: 'Betaald',
  mislukt: 'Betaling mislukt',
  verlopen: 'Betaling verlopen',
}

export const statusLabel: Record<FulfilmentStatus, string> = { nieuw: 'Nieuw', ingepakt: 'Ingepakt', verzonden: 'Verzonden' }
export const statusTone: Record<FulfilmentStatus, 'accent' | 'soft' | 'neutral'> = { nieuw: 'accent', ingepakt: 'soft', verzonden: 'neutral' }

/** De volgende stap van een bestelling; verzonden is de laatste. */
export const nextStatus: Partial<Record<FulfilmentStatus, FulfilmentStatus>> = { nieuw: 'ingepakt', ingepakt: 'verzonden' }

/** "Vandaag, 09:14" */
export const received = (at: string) => `${relativeDay(at.slice(0, 10))}, ${at.slice(11, 16)}`
